import React from 'react';
import PropTypes from 'prop-types';
import SweetAlert from 'react-bootstrap-sweetalert';
import { withTranslation } from 'react-i18next';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Button from 'components/UI/CustomButtons/Button';
// our components
import DeleteConfStyle from 'assets/jss/DeleteConfirmation';

/**
 * @description
 * Stateless component
 *
 * @param {Object} props - Props from parent.
 */
const ModalConfirmation = ({
  type,
  title,
  show,
  confirm,
  classes,
  description,
  cancel,
  confirmLabel,
  showWarningInfo,
  t,
  children,
}) => (
  <SweetAlert
    type={type}
    title={title}
    showConfirm={false}
    showCancel={false}
    onCancel={cancel}
    onConfirm={() => {}}
    closeOnClickOutside
    customClass={classes.adModalConfirmation}
    allowEscape
    show={show}
  >
    {description !== '' && (
      <div className={classes.adModalDesc}>
        <p>{description}</p>
      </div>
    )}
    <div className={classes.adModalChildren}>{children}</div>
    <p>{showWarningInfo && <b>{t('common.delete.info')}</b>}</p>
    <div className={classes.adModalBtnsSection}>
      <Button color="primary" simple onClick={cancel} id="cancelModalAction">
        {t('common.cancel')}
      </Button>
      <Button color={type} onClick={confirm} id="confirmModalAction">
        {confirmLabel}
      </Button>
    </div>
  </SweetAlert>
);

/**
 * ModalConfirmation PropTypes
 * @param classes - styles
 * @param show - boolean to show or hide modal
 * @param type - type to know the type of modal confirmation
 * @param description - message description
 * @param confirmLabel - label to confirm
 * @param showWarningInfo - show warning info about irreversible action
 * @param title - title of the element to delete
 * @param t - prop from HOC with string translations
 * @param children - children to render
 * @callback confirm - callback to confirm delete
 * @callback cancel - callback to cancel delete
 */
ModalConfirmation.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  show: PropTypes.bool.isRequired,
  confirm: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
  confirmLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  showWarningInfo: PropTypes.bool,
  t: PropTypes.func.isRequired,
  children: PropTypes.instanceOf(Object),
};

ModalConfirmation.defaultProps = {
  confirmLabel: 'Eliminar',
  description: '',
  type: 'danger',
  showWarningInfo: true,
  children: null,
};

export default withTranslation()(
  withStyles(DeleteConfStyle)(ModalConfirmation),
);
